// 产品库表头数据
export default {
  data() {
    return {
      columns: []
    };
  },
  methods: {
    getColumns() {
      let columns = [
        {
          align: 'left',
          width: 300,
          slot: 'productName',
          fixed: 'left',
          renderHeader: (h, params) => {
            return (
              <div>
                <span style="margin-right:4px">产品名称</span>
                <Poptip trigger="hover" placement="top" transfer-class-name="my-poptip left0" transfer={true}>
                  <Icon style="color:#A8ADB7;" type="md-help-circle" />
                  <div slot="content">
                    <p>当供应商产品停售、禁售或无投保权限</p>
                    <p>时产品会标记为不可售</p>
                  </div>
                </Poptip>
              </div>
            );
          }
        },
        {
          title: '保险公司',
          key: 'companyName',
          align: 'center',
          width: 100
        },
        // {
        //   title: '险种分类',
        //   key: 'themeName',
        //   align: 'center',
        //   minWidth: 120
        // }
      ];
      // if (this.settleRuleType == '1') {
      //   columns.push({
      //     align: 'center',
      //     width: 120,
      //     render: (h, params) => {
      //       if (params.row.publishStatus == 2) {
      //         return <span class="my-tag green">已上架</span>;
      //       } else {
      //         return <span class="my-tag red">已下架</span>;
      //       }
      //     },
      //     renderHeader: (h, params) => {
      //       return (
      //         <div>
      //           <span>是否上架</span>
      //           <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
      //             <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
      //             <div slot="content">
      //               <p>是：业务员展业APP显示此产品</p>
      //               <p>否：业务员展业APP不显示此产品</p>
      //             </div>
      //           </Poptip>
      //         </div>
      //       );
      //     }
      //   });
      // }
      // 非监管
      if (this.$units.superviseShowVal() && this.$units.pointAction('pro_9_3')) {
        columns.push({
          key: 'source',
          align: 'center',
          width: 130,
          renderHeader: (h, params) => {
            return (
              <div>
                <span>供应商</span>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                  <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                  <div slot="content">
                    <p>该产品和哪个保司或机构合作签约的</p>
                    <p>可到供应商管理维护供应商</p>
                  </div>
                </Poptip>
              </div>
            );
          }
        });
      }
      if (this.$units.pointAction('pro_9_4')) {
        columns.push({
          title: '服务费率',
          slot: 'fee',
          align: 'center',
          width: 120,
          tooltip: true
        });
      }
      columns = columns.concat([
        {
          title: '首期结算规则',
          slot: 'settleRule1',
          minWidth: 200
        },
        {
          title: '续期结算规则',
          slot: 'settleRule2',
          minWidth: 200
        },
        {
          title: '其他规则',
          slot: 'settleRule3',
          minWidth: 200
        }
      ]);
      this.columns = columns;
    }
  }
};
